import React, { useState } from 'react'
import { Heading, Text, Sidenav, Tag } from 'base-ui'
import { PageWrapper } from './PageWrapper'
import { IconArrowRight } from '@paro.io/base-icons'

const Sidenavs = () => {
  const [paths] = React.useState([
    {
      route: '#/navigation/sidenav',
      target: '_inApp',
      name: 'link 1',
      icon: <IconArrowRight size='sm' />
    },
    {
      route: `#/navigation/sidenav`,
      target: '_inApp',
      name: 'link 2',
      icon: <IconArrowRight size='sm' />,
      tag: <Tag
        color="warning"
        label="New!"
        borderRadius="full"
        variant="solid"
      />
    },
    {
      route: `#/navigation/sidenav`,
      target: '_inApp',
      name: 'link 3',
      icon: <IconArrowRight size='sm' />
    }
  ])

  const [isOpen, setOpen] = useState(true)
  const toggleIsOpen = () => {
    setOpen((isOpen) => !isOpen)
  }

  return (
    <PageWrapper title='Sidenav' isResponsive={true}>
      <Text size='md'>Sidenav Component</Text>
      <Heading size='h3'>Usage</Heading>

      <Sidenav
        paths={paths}
        HandleisOpen={toggleIsOpen}
        isOpen={isOpen}
        fixed={false}
        badge={'elite'}
        SidenavWidth='md:w-1/4'
        SidenavClassNames='custom-class'
        userInfo={{ avatar: 'https://picsum.photos/200', name: 'Test User' }}
      />
    </PageWrapper>
  )
}

export default Sidenavs
